export default {
  props: {}
};